export const devEnv = "production"; // another "local"

export const routes = {
  // home: devEnv === "localhost" ? "/" : "/credit-ninja-pwa/",
  // login: devEnv === "localhost" ? "/login" : "/credit-ninja-pwa/login",
  // otp: devEnv === "localhost" ? "/otp" : "/credit-ninja-pwa/otp",
  // apply: devEnv === "localhost" ? "/apply" : "/credit-ninja-pwa/apply",
  // connectBank:
  //   devEnv === "localhost" ? "/connectBank" : "/credit-ninja-pwa/connectBank",
  // customerPortal:
  //   devEnv === "localhost"
  //     ? "/customerPortal"
  //     : "/credit-ninja-pwa/customerPortal",
  home: "/",
  login: "/login",
  otp: "/otp",
  apply: "/apply",
  connectBank: "/connectBank",
  customerPortal: "/customerPortal",
  // home: "/credit-ninja-pwa/",
  // login: "/credit-ninja-pwa/login",
  // otp: "/credit-ninja-pwa/otp",
  // apply: "/credit-ninja-pwa/apply",
  // connectBank: "/credit-ninja-pwa/connectBank",
  // customerPortal: "/credit-ninja-pwa/customerPortal",
  //   "homepage": "https://santhosh-dyooti.github.io/credit-ninja-pwa",
  //   scripts: {
  //     predeploy: "npm run build",
  //     deploy: "gh-pages -d build",
  //   },
};

// Add hyphens between the ssn inputs
// reduce the space btw label and inputs
